module.exports = __webpack_public_path__ + "static/media/jira.50535b76.svg";